import { handlers } from "@/repositories/mocks/graphql/handlers";
import { setupWorker } from "msw/browser";

export const worker = setupWorker(...handlers);
